import { TableCellItem } from '@website-builder/widgets/table/table-cell-item';
import { makeEntityId } from '@website-builder/util/make-widget-id.utility';
import { EntityIdPrefix } from '@website-builder/model/domain/entity-id-prefix.enum';

export class TableRowElement {
  id = makeEntityId(EntityIdPrefix.WIDGET_SECTION);
  cells = new Array<TableCellItem>();

  constructor(noOfCells: number) {
    do {
      this.cells.push(new TableCellItem());
      noOfCells--;
    } while (noOfCells > 0);
  }

  static normalizeInPlace(element: TableRowElement): TableRowElement {
    const pureElement = new TableRowElement(0);

    element.cells = (element.cells ?? pureElement.cells).map(cell => TableCellItem.normalizeInPlace(cell));

    return element;
  }
}
